<div class="social" [ngClass]="classes">
  <a class="social__link" [href]="environment.facebook" target="_blank">
    <img
      src="assets/social-facebook.svg"
      width="128"
      height="128"
      alt="Facebook"
      class="social__image"
    />
  </a>

  <a class="social__link" [href]="environment.instagram" target="_blank">
    <img
      src="assets/social-instagram.svg"
      width="128"
      height="128"
      alt="Instagram"
      class="social__image"
    />
  </a>
</div>
